// project import
import dashboard from './dashboard';
import produksi from './produksi';
import pages from './page';
import utilities from './utilities';
import support from './support';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, produksi, pages, utilities, support]
};

export default menuItems;
